import { CSVLink } from "react-csv";
import React, { useCallback, useState } from "react";
import Button from "./Button";
import { BsFileEarmarkExcel } from 'react-icons/bs';
import buildTableData from "./buildTableData";

export default function CSV({ columns = [], list = [], title, className, btnName, notButton, icon = true }) {
  const [data, setData] = useState([]);

  const handleClick = useCallback((_event, done) => {
    try {
      const built = buildTableData(columns, list);
      setData(built);
    } finally {
      done();
    }
  }, [columns, list]);

  const fileName = (title || "data").toString().replace(/[^\w\-]+/g, "_");

  const link = (
    <CSVLink
      data={data}
      filename={fileName}
      className={className ? className : (notButton ? "whitespace-nowrap" : "text-white rounded")}
      onClick={handleClick}
      asyncOnClick
    >
      <div className="flex items-center pt-[0.1rem] gap-1">
        {icon && <BsFileEarmarkExcel size={12} />}
        {btnName || "Download CSV"}
      </div>
    </CSVLink>
  );

  return notButton ? link : <Button color="gray">{link}</Button>;
}
